module.exports = __webpack_public_path__ + "static/media/sologoazul.366843b9.png";